<div class="group grid size-4">
  <input
    #input
    [attr.id]="inputId()"
    type="checkbox"
    [checked]="checked()"
    [name]="name()"
    (change)="onCheck($event.target.checked)"
    [disabled]="disabled()"
    class="col-start-1 row-start-1 appearance-none rounded-sm border border-outline dark:border-outline-darkmode bg-surface dark:bg-surface-darkmode checked:border-primary dark:checked:border-primary-darkmode checked:bg-primary dark:checked:bg-primary-darkmode indeterminate:border-primary dark:indeterminate:border-primary-darkmode indeterminate:bg-primary dark:indeterminate:bg-primary-darkmode focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:focus-visible:outline-primary-darkmode disabled:border-gray-300 disabled:bg-deactivated-outline dark:disabled:bg-deactivated-outline-darkmode disabled:checked:bg-deactivated-outline dark:disabled:checked:bg-deactivated-outline-darkmode forced-colors:appearance-auto"
  />
  <svg
    viewBox="0 0 14 14"
    fill="none"
    class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-on-primary dark:stroke-on-primary group-has-disabled:stroke-gray-950/25"
  >
    <path
      d="M3 8L6 11L11 3.5"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="opacity-0 group-has-checked:opacity-100"
    />
    <path
      d="M3 7H11"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="opacity-0 group-has-indeterminate:opacity-100"
    />
  </svg>
</div>
